import styled from 'styled-components';
import { palette } from 'Constants/Palette';

// Inset horizontal del grid: cuánto se meten las cards desde el borde. SectionTitle
// consume esta misma constante para que el título de sección arranque en el mismo
// borde que las cards, en vez de duplicar el valor y arriesgar que se desincronicen.
// Mismo valor que el GRID_INSET de MyCourses, pero constante propia: importarlo de
// Pages/MyCourses sería un import cruzado entre páginas.
export const GRID_INSET = '1rem';

// Grid fluido: el card compartido no tiene ancho fijo (el legacy sí, 345px).
export const ListCourses = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1.5rem;
  width: 100%;
  padding: 1rem ${GRID_INSET};
`;

export const CourseSection = styled.section`
  & + & {
    margin-top: 28px;
  }
`;

// Misma estética que el SectionTitle de MyCourses, sin importar cruzado entre páginas.
// padding-left: comparte GRID_INSET con ListCourses para que el título arranque en el
// mismo borde que las cards; no es un número mágico aparte.
export const SectionTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${palette.muted};
  padding-left: ${GRID_INSET};
`;
